module.exports = __webpack_public_path__ + "static/media/mechImage.380c1e45.jpg";